var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.84 45.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.84,10.11l.11,0A.34.34,0,0,0,6.06,10l.06,0,0,0a.61.61,0,0,0,.07-.1.31.31,0,0,0,0-.1.36.36,0,0,0,0-.1.5.5,0,0,0,0-.12v0a.29.29,0,0,0,0-.09s0-.05,0-.08a.87.87,0,0,0-.11-.18l0,0A14.53,14.53,0,0,0,2.82,6.42,2.37,2.37,0,0,0,1.31,6.3,1.77,1.77,0,0,0,.14,7.47,1.88,1.88,0,0,0,1.49,10a14.58,14.58,0,0,0,4.27.12ZM1.91,8.89c-.89-.34-.74-.76-.64-1s.27-.4.38-.43a1.27,1.27,0,0,1,.76.09A8.77,8.77,0,0,1,4.31,9,9,9,0,0,1,1.91,8.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.56,6.1l.07,0,.1.06.13,0,.07,0h.15l.11,0,.09,0,.1-.08,0,0A.56.56,0,0,0,8.46,6l0-.06a.73.73,0,0,0,.06-.21v0a14.51,14.51,0,0,0-.28-4.26A2.37,2.37,0,0,0,7.34.23,1.78,1.78,0,0,0,5.69.17a1.88,1.88,0,0,0-1,2.72A14.67,14.67,0,0,0,7.56,6.1ZM6.15,1.28a.63.63,0,0,1,.58,0,1.25,1.25,0,0,1,.44.62,8.49,8.49,0,0,1,.22,2.4A8.48,8.48,0,0,1,5.85,2.43C5.48,1.55,5.9,1.38,6.15,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M48.64,33.76V6.09A2.65,2.65,0,0,0,46,3.44h-.28a2.65,2.65,0,0,0-2.64,2.65V33.76a6.06,6.06,0,0,0-2.61,2.71H7.24A2.64,2.64,0,0,0,4.6,39.11v.27a2.62,2.62,0,0,0,1.82,2.5L9,44.46a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29L12.85,42H40.67a6,6,0,1,0,8-8.27Zm-3.56-.69v-27a.65.65,0,0,1,.64-.65H46a.65.65,0,0,1,.64.65v27ZM9.71,42.34,9.39,42H10ZM39.88,40H7.24a.65.65,0,0,1-.64-.65v-.27a.64.64,0,0,1,.64-.64H39.88Zm6,3a4,4,0,1,1,4-4A4,4,0,0,1,45.86,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.86,37.28a1.78,1.78,0,1,0,1.78,1.78A1.78,1.78,0,0,0,45.86,37.28Zm-.22,1.78a.22.22,0,0,1,.44,0C46.08,39.3,45.64,39.3,45.64,39.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.66,12.4v.95H8a1,1,0,0,0-1,1v9.57a1,1,0,0,0,2,0V15.35h5.35v11a.5.5,0,0,1-.5.5H7.1a2.51,2.51,0,0,0,0,5H17.9V33a2.64,2.64,0,0,0,2.64,2.64h.28A2.64,2.64,0,0,0,23.46,33V6.63A2.65,2.65,0,0,0,20.82,4h-.28A2.65,2.65,0,0,0,17.9,6.63V29.88H7.1a.51.51,0,0,1,0-1h6.73a2.5,2.5,0,0,0,2.5-2.5v-12a1,1,0,0,0-1-1H12.66V12a1,1,0,0,0-.3-.71L10.81,9.73A1,1,0,0,0,9.4,11.14ZM19.9,6.63A.65.65,0,0,1,20.54,6h.28a.65.65,0,0,1,.64.65V33a.64.64,0,0,1-.64.64h-.28A.64.64,0,0,1,19.9,33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.84,
    y: 7.57,
    width: 4.26,
    height: 24.46,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 31.23,
    y: 7.57,
    width: 4.26,
    height: 24.46,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.62,
    y: 7.57,
    width: 4.26,
    height: 24.46,
    rx: 2.13
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReel);
export default __webpack_public_path__ + "static/media/Reel.f0ef2759.svg";
export { ForwardRef as ReactComponent };